'use client';

import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

export const FooterSocialMediaShare = (props: { color: string; title?: string; tagLine?: string }) => {
	const [url, setUrl] = useState('');

	const iconStyles = {
		width: 26,
		height: 26,
		color: props.color === 'white' ? 'white' : 'black',
		border: `1px solid ${props.color === 'white' ? 'white' : '#bbb'}`,
		borderRadius: 26,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	};

	useEffect(() => {
		setUrl(window.location.origin);
	}, []);

	return (
		<Box display="flex" width={1 / 3} justifyContent="flex-end">
			<Box maxWidth={1 / 3} display="flex" alignItems="center" mr={1}>
				<a
					target="_blank"
					href={`https://twitter.com/share?text=${props.title}&url=${url}`}
					style={iconStyles}
					rel="noreferrer"
				>
					<FaTwitter />
				</a>
			</Box>
			<Box maxWidth={1 / 3} display="flex" alignItems="center" mr={1}>
				<a
					target="_blank"
					href={`https://www.instagram.com/worldcoo?utm_source=web`}
					style={iconStyles}
					rel="noreferrer"
				>
					<FaInstagram />
				</a>
			</Box>
			<Box maxWidth={1 / 3} display="flex" alignItems="center">
				<a
					href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${props.title}&summary=${
						props.tagLine ?? props.title
					}&source=${url}`}
					target="_blank"
					style={iconStyles}
					rel="noreferrer"
				>
					<FaLinkedin />
				</a>
			</Box>
		</Box>
	);
};
